import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  disabled: {
    pointerEvents: 'none',
    opacity: 0.6,
  },
}));
